import { io } from 'socket.io-client';

/**
 * ServerMonitClient
 *
 * Socket.IO Client for connecting to the websocket node server
 *
 * @param {string} domain URL to connect to eg: "http://127.0.0.1. Default is current protocol and hostname
 *
 */
class WSClient {

    constructor() {
        this.url = `${window.location.origin}`;
        const path = `/xassets/websocket/socket.io`;

        console.log('Connecting to: ' + this.url);

        this.socket = io(this.url, {
            transports: ['websocket'],
            closeOnBeforeunload: true, // Whether to (silently) close the connection when the beforeunload event is emitted in the browser.
            extraHeaders: {},
            path: path, // Default value: /socket.io/ - Path is rewritten in nginx to /127.0.0.1:1337
            reconnectionAttempts: 10,
            addTrailingSlash: false
        });

        this.addEvents();
    }

    /**
     * Add the standard listening events to the socketServer
     */
    addEvents() {
        this.on('connect', (data) => {
            this.onConnected(data);
        });
        this.on('disconnect', (data) => {
            this.onDisconnected(data);
        });
        this.on('connect_error', (data) => {
            this.onConnectionFailed(data);
        });

        this.socket.io.on('error', (data) => {
            // console.error('Error: ', data);
        });

        this.socket.io.on('reconnect', (attempt) => {
            console.log(`Reconnect successfull (${attempt})`);
        });

        this.socket.io.on('reconnect_attempt', (data) => {
            // console.log('Reconnect Attempt: ', data);
        });

        this.socket.io.on('reconnect_error', (error) => {
            // console.error('Reconnect Error: ', error);
        });

        this.socket.io.on('reconnect_failed', () => {
            console.log('Reconnect Failed! Waiting for better times ...');
        });

        // Refresh try if offline when window is back online
        window.addEventListener('focus', () => {
            // if socket is not connected
            if (this.socket.connected === false) {
                console.log('Online again! Trying to reconnect ...');
                this.socket.connect();
            }
        });
    }

    /**
     * Add an event listener to the socketServer
     *
     * @param event
     * @param callback
     */
    on(event, callback) {
        if (this.socket.hasListeners(event)) {
            this.off(event);
        }
        this.socket.on(event, callback);
    }

    /**
     * Remove an event listen from the socketServer
     *
     * @param event
     * @param callback
     */
    off(event, callback) {
        if (callback) {
            this.socket.off(event, callback);
        } else {
            this.socket.off(event);
        }
    }

    /**
     * Emits an event to the connected socketServer namespace
     *
     * @param event
     * @param data
     */
    emit(event, data) {
        this.socket.emit(event, data);
    }

    /**
     * Default function to call on connected event
     *
     * @param data
     */
    onConnected(data) {
        console.log('Connection established ...');
    }

    /**
     * Default function to call on disconnected event
     *
     * @param data
     */
    onDisconnected(data) {
        console.log('Connection lost ...');
    }

    onConnectionFailed(data) {
        // console.log('Connection failed ...', data);
    }

}

export default WSClient;
